"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  primary: "#0069d9",
  accent: "#681aea",
  white: "#fff",
  black: "rgb(34, 34, 34)",
  error: "#cc1e1e",
  warn: "#dc700b",
  success: "#1c8250",
  font: "Bozon, sans-serif"
}; // old primary: "#007CFF",
// old success: "#00caa8", "#4caf50",
// old error: "#ff5666","#fc3251",
// old warn: "#ffd600",